import PosthogService from '~/services/posthog/PosthogService';

export interface IEditShiftAutoconfirmFavoriteSelectedPayload {
  autoConfirm: 'on' | 'off';
  designDate: number;
}

/**
 * Fires when a user turns autoconfirm favorites ON/OFF on the edit shift page
 * Event: dental_portal:edit_shift:autoconfirm_favorite_selected
 */
export function fireEditShiftAutoconfirmFavoriteSelected(
  payload: IEditShiftAutoconfirmFavoriteSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:edit_shift:autoconfirm_favorite_selected',
    {
      'auto-confirm': payload.autoConfirm,
      design_date: payload.designDate,
    },
  );
}
